import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface IMyPlaceService {
  token: string;
  reqBody?: ReqBodyType;
}

class MyPlaceService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_NEST_API ?? '', false);
  }

  getMyPlaceData = async ({
    token,
    reqBody,
  }: IMyPlaceService) => {
    return this.httpClient.post({
      token,
      path: '/admission-radar',
      reqBody,
    });
  };
}

export default new MyPlaceService();
